export default __webpack_public_path__ + "static/media/s4.16bc57fd.svg";